

export const backendUrl: string = 'https://cthapi.digitalberd.com'
// export const backendUrl: string = 'http://localhost:8001'
export const siteOrigin: string = backendUrl


